module.exports = __webpack_public_path__ + "img/success.fcf21e03.svg";